<template>
	<div class="getVerificationCode flex-cen" @click="getVerificationCodeFn()">
		{{ btnText }}
	</div>
</template>

<script>
export default {
	props: {
		code: {
			type: String,
			default: ''
		},
		mobile: {
			require: true
		},
		// smsType: VALID_REGISTER:注册，UPDATE_PWD:修改密码验证码 PUSH_DEMAND 需求发布  CHANGE_PHONE
		smsType: {
			type: String,
			default: '',
			require: true
		}
	},
	name: 'SmsSend',
	// import引入的组件需要注入到对象中才能使用
	components: {},
	data() {
		// 这里存放数据
		return {
			btnText: '获取验证码',
			btnBool: false,
			loading: false,
			active: false
		}
	},
	// 生命周期 - 创建完成（可以访问当前this实例）
	created() {},
	// 方法集合
	methods: {
		// 获取验证码
		async getVerificationCodeFn() {
			if (this.btnBool) return
			if (!this.mobile) {
				this.$message.warning('请输入手机号码')
				return
			}
			let params = {
				code: this.code,
				mobile: this.mobile,
				smsType: this.smsType
			}
			console.log(params)
			console.log(this.$store.state.user.userInfo.phoneNumber)
			// let res = await this.$http.get(this.$const.common.sendVerifyEmail + '?num=' + this.mobile, '')
			// if (res && res.data) {
			// 	this.loading = false
			// 	this.$message.success(this.$PubText.smsSuccess)
			// 	this.countdown()
			// }
		},
		async getVerificationCodeFnold() {
			if (this.btnBool) return
			if (!this.mobile) {
				this.$message.warning('请输入手机号码')
				return
			}
			let params = {
				code: this.code,
				mobile: this.mobile,
				smsType: this.smsType
			}
			console.log(this.$store.state.user.userInfo.phoneNumber)
			// return false;
			try {
				this.loading = true
				if (this.smsType == 'PUSH_DEMAND') {
					//需求发布
					let res = await this.$http.post(this.$const.common.getdemandSmsSend + '?phoneNumber=' + this.mobile, '')
					if (res && res.data) {
						this.loading = false
						this.$message.success(this.$PubText.smsSuccess)
						this.countdown()
					}
				} else if (this.smsType == 'CHANGE_PHONE') {
					//更换手机号
					let res = await this.$http.post(this.$const.common.getupdateTEL + '?phoneNumber=' + this.mobile, '')
					if (res && res.data) {
						this.loading = false
						this.$message.success(this.$PubText.smsSuccess)
						this.countdown()
					}
				} else if (this.smsType == 'UPDATE_PWD' && this.$store.state.user.userInfo.phoneNumber) {
					//修改密码验证码
					let res = await this.$http.post(this.$const.common.getupdatePwdSmsSend, '')
					if (res && res.data) {
						this.loading = false
						this.$message.success(this.$PubText.smsSuccess)
						this.countdown()
					}
				} else {
					//登录 注册  忘记密码
					let res = await this.$http.post(this.$const.common.getSmsSend, params)
					if (res && res.data) {
						this.loading = false
						this.$message.success(this.$PubText.smsSuccess)
						this.countdown()
					}
				}
			} catch (e) {
				this.loading = false
				console.log(e)
			}
		},
		countdown() {
			//验证码倒计时
			this.btnBool = true
			let i = 60 //倒计时时间
			let timer = setInterval(() => {
				this.btnText = (i < 10 ? '0' + i : i) + 'S 后重新获取'
				i--
				if (i < 0) {
					this.btnBool = false
					this.btnText = '获取验证码'
					clearInterval(timer)
				}
			}, 1000)
		}
	}
}
</script>

<style lang="scss" scoped>
.getVerificationCode {
	width: 175px;
	height: 100%;
	padding: 0 6px;
	border-radius: 0;
	transition: 0.5s;
	text-align: center;
	cursor: pointer;
	box-sizing: border-box;
	outline: 0;
	margin: 0;
	font-weight: 500;
	font-size: 14px;
	border: 1px solid #dcdfe6;
	background: #ecf5ff;
	color: #409eff;

	&:hover {
		background: #3a8ee6;
		border-color: #3a8ee6;
		color: #fff;
	}
}
</style>